<template>
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card card-primary">
            <div class="card-header bg-primary text-white">
              <h3 class="card-title">
                <i class="fas fa-search mr-2"></i>Consulta de Materiais para Transporte
              </h3>
              <div class="card-tools">
                <button type="button" class="btn btn-tool" data-card-widget="collapse">
                  <i class="fas fa-minus"></i>
                </button>
              </div>
            </div>

            <div class="card-body">
              <div class="alert alert-info">
                <i class="icon fas fa-info-circle"></i> Selecione um material abaixo para verificar as condições de
                transporte
              </div>

              <div class="row">
                <div class="col-md-8 offset-md-2">
                  <div class="form-group">
                    <label class="font-weight-bold">
                      <i class="fas fa-flask mr-2"></i>Selecione o Material
                    </label>
                    <ProductSelect :products="products" @selected="handleProductSelected"
                      placeholder="Digite o nome ou número UN do material..." />
                  </div>
                </div>
              </div>

              <div v-if="selectedProduct" class="mt-4">
                <div class="form-group">
                  <label class="font-weight-bold">
                    <i class="fas fa-question-circle mr-2"></i>Este material consiste em corpo (inteiro/parte) ou órgão?
                  </label>
                  <div class="d-flex flex-wrap">
                    <div class="custom-control custom-radio mr-3">
                      <input class="custom-control-input" type="radio" id="corpoSim" value="y"
                        v-model="form.corpo_inteiro">
                      <label for="corpoSim" class="custom-control-label">
                        <i class="fas fa-check-circle text-success mr-1"></i> Sim
                      </label>
                    </div>
                    <div class="custom-control custom-radio">
                      <input class="custom-control-input" type="radio" id="corpoNao" value="n"
                        v-model="form.corpo_inteiro">
                      <label for="corpoNao" class="custom-control-label">
                        <i class="fas fa-times-circle text-danger mr-1"></i> Não
                      </label>
                    </div>
                  </div>
                </div>

                <transition name="fade">
                  <div v-if="form.corpo_inteiro === 'n'" class="row mt-3">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="font-weight-bold">
                          <i class="fas fa-balance-scale mr-2"></i>Quantidade de material
                        </label>
                        <div class="input-group">
                          <input type="text" class="form-control" v-model="quantity" step="any" @input="validateInput"
                            placeholder="Ex: 1,5">
                          <div class="input-group-append">
                            <span class="input-group-text">
                              <i class="fas fa-hashtag"></i>
                            </span>
                          </div>
                        </div>
                        <small class="form-text text-muted">
                          Digite a quantidade em números (use vírgula para decimais)
                        </small>
                        <div class="alert alert-light mt-2">
                          <i class="fas fa-calculator mr-2"></i>
                          <strong>Quantidade convertida:</strong> {{ formattedQuantity }}
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="font-weight-bold">
                          <i class="fas fa-ruler-combined mr-2"></i>Unidade de medida
                        </label>
                        <select v-model="selectedUnit" name="unit" class="form-control custom-select">
                          <option selected disabled>Selecione a unidade...</option>
                          <option value="litro">
                            <i class="fas fa-tint"></i> Litro (L)
                          </option>
                          <option value="quilo">
                            <i class="fas fa-weight"></i> Quilograma (kg)
                          </option>
                          <option value="grama">
                            <i class="fas fa-weight"></i> Grama (g)
                          </option>
                          <option value="mililitro">
                            <i class="fas fa-tint"></i> Mililitro (ml)
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>

      <transition name="slide-fade">
        <div class="row mt-3" v-if="selectedProduct && this.form.corpo_inteiro.length">
          <div class="col-12">
            <div class="card card-success">
              <div class="card-header bg-success text-white">
                <h3 class="card-title">
                  <i class="fas fa-file-alt mr-2"></i>Resultado da Consulta
                </h3>
                <div class="card-tools">
                  <button type="button" class="btn btn-sm btn-light" @click="printPdf" :disabled="!pdfUrl">
                    <i class="fas fa-print mr-1"></i>
                    Imprimir Guia
                  </button>
                </div>
              </div>

              <div class="card-body">
                <div class="row mb-4">
                  <div class="col-md-12">
                    <div class="callout callout-info">
                      <h5>
                        <i class="fas fa-box mr-2"></i>
                        Material selecionado:
                        <strong>{{ selectedProduct.descricao }}</strong>
                        <span class="badge badge-primary ml-2">
                          UN {{ selectedProduct.numero_un || 'N/A' }}
                        </span>
                      </h5>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="info-box bg-gradient-info">
                      <span class="info-box-icon">
                        <i class="fas fa-exclamation-triangle"></i>
                      </span>
                      <div class="info-box-content">
                        <span class="info-box-text">Limites de Quantidades</span>
                        <span class="info-box-number">{{ calcularLimiteQuantidade }}</span>
                        <div class="progress">
                          <div class="progress-bar" style="width: 100%"></div>
                        </div>
                        <span class="progress-description">
                          <i class="fas fa-info-circle mr-1"></i>
                          Consulte sempre as regulamentações atualizadas
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="info-box bg-gradient-success">
                      <span class="info-box-icon">
                        <i class="fas fa-shipping-fast"></i>
                      </span>
                      <div class="info-box-content">
                        <span class="info-box-text">Nome para Embarque</span>
                        <span class="info-box-number">
                          {{ selectedProduct.nome_apropriado_transporte || 'N/A' }}
                        </span>
                        <div class="progress">
                          <div class="progress-bar" style="width: 100%"></div>
                        </div>
                        <span class="progress-description">
                          <i class="fas fa-tag mr-1"></i>
                          Designação oficial para documentação
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mt-4">
                  <div class="col-md-12">
                    <div class="card card-warning">
                      <div class="card-header">
                        <h3 class="card-title">
                          <i class="fas fa-file-pdf mr-2"></i>
                          Guia de Embarque Requerida
                        </h3>
                      </div>
                      <div class="card-body">
                        <div class="alert" :class="guideValueClass">
                          <h5>
                            <i :class="guideValueIcon"></i>
                            {{ guideValueText }}
                          </h5>
                          <p v-if="guideValueDetails" class="mb-0">
                            {{ guideValueDetails }}
                          </p>
                        </div>

                        <div v-if="pdfUrl" class="text-center mt-3">
                          <button class="btn btn-primary mb-3" @click="printPdf">
                            <i class="fas fa-print mr-2"></i>
                            Imprimir Guia Completa
                          </button>

                          <div class="pdf-container border p-2">
                            <div v-for="page in numPages" :key="page" class="pdf-page mb-2">
                              <pdf :src="pdfUrl" :page="page" style="width: 100%;"></pdf>
                            </div>
                          </div>
                        </div>
                        <div v-else class="text-center text-muted py-4">
                          <i class="fas fa-file-pdf fa-3x mb-2"></i>
                          <p>Nenhum documento requerido ou disponível</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </section>
</template>

<script>
import pdf from 'vue-pdf'
import ProductSelect from "./ProductSelect.vue";

export default {
  components: {
    ProductSelect,
    pdf
  },
  data() {
    return {
      title: 'Consulta',
      products: [],
      pdfUrl: null,
      quantity: '',
      selectedUnit: 'litro',
      selectedProduct: null,
      form: {
        corpo_inteiro: '',
      },
      numPages: 0,
    }
  },
  computed: {
    formattedQuantity() {
      if (!this.quantity) return "Nenhuma quantidade informada";
      const qtyBase = this.convertToBaseUnit(this.quantity, this.selectedUnit);
      const baseUnit = this.selectedUnit === 'litro' || this.selectedUnit === 'mililitro' ? 'ml' : 'g';
      return `${qtyBase.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${baseUnit}`;
    },

    calcularLimiteQuantidade() {
      if (!this.selectedProduct) return "Selecione um material primeiro";

      if (this.form.corpo_inteiro === "y") {
        return "Sem limite de quantidade (corpo/órgão)";
      }

      if (this.selectedProduct.nome_apropriado_transporte === "Biological substance, Category B") {
        return "Até 4L/kg para qualquer aeronave";
      }

      return "Até 50ml/g (passageiros) ou 4L/kg (carga)";
    },

    guideValueText() {
      if (!this.selectedProduct) return "Material não selecionado";
      if (this.form.corpo_inteiro === "y") return "Documentação para corpo/órgão";

      const qtyBase = this.convertToBaseUnit(this.quantity, this.selectedUnit);

      if (qtyBase > 4000) return "Documentação para mais de 4L/kg";
      if (qtyBase > 50) return "Documentação para 50ml/g - 4L/kg";
      if (qtyBase > 0) return "Documentação para até 50ml/g";

      return "Informe a quantidade";
    },

    guideValueDetails() {
      if (!this.selectedProduct) return "";
      if (this.form.corpo_inteiro === "y") return "Material isento de limites quantitativos por se tratar de corpo (inteiro ou parte) ou órgão humano.";

      const qtyBase = this.convertToBaseUnit(this.quantity, this.selectedUnit);

      if (qtyBase > 4000) return "Material acima de 4 litros ou 4kg requer documentação especial para transporte em aeronaves cargueiras.";
      if (qtyBase > 50) return "Material entre 50ml/50g e 4L/4kg requer documentação específica conforme regulamentações.";
      if (qtyBase > 0) return "Material em pequenas quantidades (até 50ml ou 50g) possui requisitos simplificados de documentação.";

      return "";
    },

    guideValueClass() {
      if (!this.selectedProduct) return "alert-secondary";
      if (this.form.corpo_inteiro === "y") return "alert-success";

      const qtyBase = this.convertToBaseUnit(this.quantity, this.selectedUnit);

      if (qtyBase > 4000) return "alert-danger";
      if (qtyBase > 50) return "alert-warning";
      if (qtyBase > 0) return "alert-info";

      return "alert-secondary";
    },

    guideValueIcon() {
      if (!this.selectedProduct) return "fas fa-question-circle";
      if (this.form.corpo_inteiro === "y") return "fas fa-check-circle";

      const qtyBase = this.convertToBaseUnit(this.quantity, this.selectedUnit);

      if (qtyBase > 4000) return "fas fa-exclamation-circle";
      if (qtyBase > 50) return "fas fa-exclamation-triangle";
      if (qtyBase > 0) return "fas fa-info-circle";

      return "fas fa-question-circle";
    },

    guideValue() {
      // Mantido para compatibilidade (pode ser removido após testes)
      return this.guideValueText;
    }
  },
  watch: {
    quantity: 'updateGuideValue',
    selectedUnit: 'updateGuideValue',
    selectedProduct: 'updateGuideValue',
    'form.corpo_inteiro'(val) {
      if (val === 'y') {
        this.quantity = '';
        this.selectedUnit = '';
        this.pdfUrl = this.selectedProduct?.guia_orgao_parte_corpo_quantidade_liberada || null;
      } else if (val === 'n') {
        this.pdfUrl = null;
      }
    },
    pdfUrl: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.loadPdfPages(newVal);
        }
      },
    },
  },
  methods: {
    async loadProducts() {
      try {
        const response = await axios.get("api/product/list");
        this.products = response.data.map(item => ({
          id: item.id,
          descricao: item.descricao,
          ...item
        }));
      } catch (error) {
        console.error("Erro ao buscar materiais:", error);
        this.$toast.error("Erro ao carregar lista de materiais");
      }
    },

    handleProductSelected(product) {
      this.selectedProduct = product;
      this.form.corpo_inteiro = '';
      this.quantity = '';
      this.selectedUnit = 'litro';
    },

    validateInput(event) {
      let value = event.target.value.replace(/[^0-9,]/g, '');
      const parts = value.split(',');
      if (parts.length > 2) {
        value = parts[0] + ',' + parts.slice(1).join('');
      }
      this.quantity = value;
    },

    printPdf() {
      if (this.pdfUrl) {
        const newWindow = window.open(this.pdfUrl, '_blank');
        if (newWindow) {
          newWindow.focus();
        } else {
          this.$toast.error("O bloqueador de pop-ups pode estar ativo. Permita pop-ups para este site.");
        }
      } else {
        this.$toast.warning("Nenhum documento disponível para impressão");
      }
    },

    updateGuideValue() {
      if (!this.selectedProduct || this.form.corpo_inteiro === 'y') return;

      const qty = parseFloat(this.quantity.replace(',', '.')) || 0;
      const unit = this.selectedUnit;

      // Converter todas as unidades para base (gramas ou mililitros)
      let convertedQty = qty;
      if (unit === "quilo") convertedQty = qty * 1000; // kg para g
      if (unit === "litro") convertedQty = qty * 1000; // L para ml

      // Determinar o guia com base na quantidade convertida
      if (convertedQty > 4000) {
        this.pdfUrl = this.selectedProduct.guia_acima_4l_ou_4kg;
      } else if (convertedQty > 50) {
        this.pdfUrl = this.selectedProduct.guia_acima_50ml_ou_50g_ate_4l_ou_4kg;
      } else if (convertedQty > 0) {
        this.pdfUrl = this.selectedProduct.guia_ate_50ml_ou_50g;
      } else {
        this.pdfUrl = null;
      }
    },

    convertToBaseUnit(quantity, unit) {
      const qty = parseFloat(quantity.replace(',', '.')) || 0;
      switch (unit) {
        case "quilo": return qty * 1000;    // kg → g
        case "litro": return qty * 1000;    // L → ml
        case "grama": return qty;           // g → g
        case "mililitro": return qty;       // ml → ml
        default: return qty;
      }
    },

    async loadPdfPages(pdfUrl) {
      try {
        const loadingTask = pdf.createLoadingTask(pdfUrl);
        const loadedPdf = await loadingTask.promise;
        this.numPages = loadedPdf.numPages;
      } catch (error) {
        console.error("Erro ao carregar o PDF:", error);
        this.$toast.error("Erro ao carregar documento PDF");
      }
    },
  },

  created() {
    this.$Progress.start();
    this.loadProducts();
    this.$Progress.finish();
  },
}
</script>

<style scoped>
/* Efeitos de transição */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(10px);
  opacity: 0;
}

/* Estilo para o container do PDF */
.pdf-container {
  background-color: #f8f9fa;
  border-radius: 5px;
  overflow: auto;
  max-height: 500px;
}

/* Melhorias nos cards */
.card-header {
  border-bottom: none;
}

/* Estilo para os info-box */
.info-box {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
}

/* Responsividade */
@media (max-width: 768px) {
  .pdf-container {
    max-height: 300px;
  }
}

@media print {

  .no-print,
  .card-tools,
  .btn {
    display: none !important;
  }

  body {
    padding: 0;
    margin: 0;
  }
}
</style>